

/**
 * @classdesc Handler formulaire de paiement d'une inscription Admin
 * @kind class
 * @export
 * @class Paiement_Admin
 */
export default class Paiement_Admin {
    moyen_de_paiement = "Chèque";
    prix_base = 0;
    prix_apres_remise = 0;
    remise = 0;

    /**
     * Creates an instance of Paiement_Admin.
     * @constructs
     * @kind function
     * @memberof Paiement_Admin
     */
    constructor() { }

    async init() {

    }

}